import styled from "styled-components"
import { Row, Column } from "styled-grid-system-component"

const Styles = {
  Header: styled.h4({
    textAlign: "center",
    fontSize: "32px",
    textTransform: "uppercase",
    marginBottom: "25px",
    lineHeight: "32px",
    fontWeight: "400",
  }),
  RowMargined: styled(Row)`
    margin-bottom: 45px;
  `,
  ColMargined: styled(Column)`
    margin-bottom: 30px;
  `,
  List: styled.ul({
    listStyle: "square",
    paddingLeft: "15px",
  }),
  ListItem: styled.li({}),
  BorderOffset: "-5px",
  BorderRadius: "20px",
}
export default Styles
